import { Dropdown, Form } from 'antd';

import PlusRoundOutlined from '../../../../assets/common/PlusRoundOutlined';
import HelpCenterIcon from '../../../../assets/HelpCenterIcon';
import { AppForm } from '../../../../CommonComponents/AppForm/AppForm';
import AppTextArea from '../../../../CommonComponents/UI/AppTextArea/AppTextArea';
import ExtractionFieldContainer from './ExtractionFieldContainer';
import styles from './PromptContainer.module.scss';

const popupRender = () => {
  return (
    <section className={styles.prompt_help_dropdown_section}>
      <p className='mb-16'>Persona and task mode apply to all fields below</p>
      <p>
        Example: You are a commercial contracts reviewer identifying risks and extracting key terms.
      </p>
    </section>
  );
};

const PromptContainer = ({ form, defaultExtractionField }) => {
  return (
    <section className={styles?.prompt_container}>
      <div className={`${styles.title} mb-8`}>
        <span className='fw-600'>
          Prompt
          <span className='color-danger'>*</span>
        </span>
      </div>

      <div className={styles.persona_task_container}>
        <Dropdown popupRender={popupRender} destroyOnHidden>
          <span role='img' className={styles.persona_task_help_icon}>
            <HelpCenterIcon size={16} fill='#738090' />
          </span>
        </Dropdown>

        <AppForm.Item
          label='Persona & Task'
          name='personaPrompt'
          rules={[{ required: true, message: 'Please enter a prompt.' }]}
        >
          <AppTextArea
            placeholder='Set a persona and describe the overall task to be performed.'
            rows={3}
          />
        </AppForm.Item>
        <div className={styles.extraction_fields}>
          <p className='mt-16 fw-600 mb-8'>Extraction Fields</p>

          <Form.List
            name='extractionFields'
            initialValue={[defaultExtractionField()]}
            rules={[
              {
                validator: async (_, fields) => {
                  if (!fields || fields.length === 0) {
                    return Promise.reject(new Error('Add at least one extraction field.'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                <ul>
                  {fields.map((field, index) => (
                    <ExtractionFieldContainer
                      key={field.key}
                      field={field}
                      index={index}
                      form={form}
                      canDelete={fields.length > 1}
                      onDelete={() => remove(field.name)}
                    />
                  ))}
                </ul>

                <Form.ErrorList errors={errors} />

                <button
                  type='button'
                  className='flex gap-8 color-primary fw-500 align-center'
                  onClick={() => {
                    // Validate current fields before adding a new one
                    const currentFields = form.getFieldValue('extractionFields') ?? [];
                    form
                      .validateFields(
                        currentFields.flatMap((_, i) => [
                          ['extractionFields', i, 'extractionFieldName'],
                          ['extractionFields', i, 'extractionInstruction'],
                          ['extractionFields', i, 'outputType'],
                        ])
                      )
                      .then(() => {
                        add(defaultExtractionField());
                      })
                      .catch(() => {
                        // Validation errors are shown inline — do nothing
                      });
                  }}
                >
                  <PlusRoundOutlined />
                  <span>Add Extraction Field</span>
                </button>
              </>
            )}
          </Form.List>
        </div>
      </div>
    </section>
  );
};

export default PromptContainer;
